import { EntityType } from '@frontend/common';
import { IEquipment } from '@frontend/equipment/types';
import { Equipment } from '@frontend/equipment/utils';
import { IGroup } from '@frontend/group/types';
import { Group } from '@frontend/group/utils';
import { IProduct } from '@frontend/product/types';
import { Product } from '@frontend/product/utils';
import { IMAGE_MIME_TYPES, useBlobRepository, useDocumentRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import { ImageContainerProps } from './image-container.component';

export const useImageContainer = <T>(props: ImageContainerProps<T>) => {
    const blobRepository = useBlobRepository();
    const documentRepository = useDocumentRepository();
    const [image, changeImage] = useState<string | null | undefined>(undefined);

    async function fetchImage() {
        switch (props.entity_type) {
            case EntityType.PRODUCT: {
                const product = new Product(props.entity as IProduct);
                return (await product.getBlobImage(blobRepository)) ?? product.getImage(documentRepository);
            }
            case EntityType.PRODUCT_CATEGORY: {
                const group = new Group(props.entity as IGroup);
                return (
                    (await group.getBlobImage(blobRepository, EntityType.PRODUCT_CATEGORY)) ?? group.getImage(documentRepository, EntityType.PRODUCT_CATEGORY)
                );
            }
            case EntityType.EQUIPMENT: {
                const equipment = new Equipment(props.entity as IEquipment);
                return (await equipment.getBlobImage(blobRepository)) ?? equipment.getImage(documentRepository);
            }
            default: {
                const entity = props.entity as { account_id?: string; id?: string };
                if (!entity.account_id || !entity.id) return null;
                const blob = await blobRepository.getBlob(entity.account_id, props.entity_type, entity.id);
                return blob && IMAGE_MIME_TYPES.includes(blob.mimeType) ? blob.url : null;
            }
        }
    }

    useEffect(() => {
        fetchImage().then(changeImage).catch();
    }, [props.entity]);

    return {
        image
    };
};
